import { StatusApplicationCode } from 'const';

export const isCanceledStatus = (status: number) =>
  status === StatusApplicationCode.applicationsCanceled || status === StatusApplicationCode.eventCanceled;

export const mapStatusToFilterStatus = (status: number) =>
  isCanceledStatus(status) ? StatusApplicationCode.canceled : status;

type WithStatusApplication = {
  statusApplication: number;
};

export const filterApplicationEntites =
  <T extends WithStatusApplication>(applicationStatusCode: number | null) =>
  (entity: T): boolean => {
    if (!applicationStatusCode) {
      return true;
    }

    if (applicationStatusCode === StatusApplicationCode.canceled) {
      return (
        entity.statusApplication === StatusApplicationCode.applicationsCanceled ||
        entity.statusApplication === StatusApplicationCode.eventCanceled
      );
    }

    return entity.statusApplication === applicationStatusCode;
  };
